import MetadataMappingListStore from '@/modules/metadata-mapping/store/metadata-mapping-list-store';

export default {
    namespaced: true,

    modules: {
        list: MetadataMappingListStore,
    },
};
